import { Injectable } from '@angular/core';
import {
  ApiCallHandler,
  EoHttpClient,
  IDataService,
  IHttpParams,
  PaginatedSearchResult,
  STATUS,
} from 'ngx-eo-web-components';
import { CoreService } from '../../modules/core/core.service';
import { ISortParams } from '../../modules/shared/models/sort.model';
import { Observable } from 'rxjs';
import { Surgery } from '../../modules/core/models/surgery.model';
import { SurgeryDoctor } from '../../modules/core/models/surgery-doctor.model';

@Injectable({
  providedIn: 'root',
})
export class SurgeryCitizenService implements IDataService<Surgery> {
  constructor(private http: EoHttpClient, private coreService: CoreService) {}
  public searchCh = new ApiCallHandler<PaginatedSearchResult<Surgery> | null>();
  public changeSurgeryPrivateHospitalCallHandler = new ApiCallHandler<any>();
  public surgeryFetchCallHandler = new ApiCallHandler<Surgery>();

  init() {
    this.searchCh.init();
    this.surgeryFetchCallHandler.init();
  }

  getSurgeryById(surgeryId: string) {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Surgeries/fetch/${surgeryId}`,
      this.surgeryFetchCallHandler
    );
    return this.http.get<Surgery>(param);
  }
  searchCitizenSurgeries(
    searchParams: {
      patientAmka: string | null;
      sortParams?: ISortParams | null;
    },
    pagesize: number,
    page: number
  ): Observable<PaginatedSearchResult<Surgery>> {
    const param: IHttpParams = this.coreService.initCall(
      `/v1/Surgeries/searchCitizen/${pagesize}/${page}`,
      this.searchCh,
      searchParams
    );

    return this.http.post<PaginatedSearchResult<Surgery>>(param);
  }

  changePrivateHospitalByCitizen(surgeryID: string) {
    const param: IHttpParams = this.coreService.initCall(
      '/v1/Surgeries/changePrivateHospitalByCitizen',
      this.changeSurgeryPrivateHospitalCallHandler,
      { SurgeryID: surgeryID }
    );
    return this.http.post(param);
  }
}
